var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main_container" }, [
    _c(
      "div",
      {
        staticClass: "container-fluid edit-story-wrapper",
        class: _vm.selectedNodeType
      },
      [
        _c("div", { staticClass: "panel-wrapper" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "simulation-controls" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn", on: { click: _vm.hidePlayAndPause } },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        id: "pause_SVG",
                        width: "15",
                        height: "21",
                        viewBox: "0 0 15 21",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M2.63068 20.0757C1.2967 20.0757 0.215942 18.9949 0.215942 17.661V2.56684C0.215942 1.23286 1.2967 0.1521 2.63068 0.1521C3.96465 0.1521 5.04541 1.23286 5.04541 2.56684V17.661C5.04661 18.9949 3.96465 20.0757 2.63068 20.0757Z",
                          fill: "white"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M12.2908 20.0757C10.9569 20.0757 9.8761 18.9949 9.8761 17.661V2.56684C9.8761 1.23286 10.9569 0.1521 12.2908 0.1521C13.6248 0.1521 14.7057 1.23286 14.7057 2.56684V17.661C14.7057 18.9949 13.6248 20.0757 12.2908 20.0757Z",
                          fill: "white"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      attrs: {
                        id: "play_SVG",
                        width: "25",
                        height: "28",
                        viewBox: "0 0 25 28",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M0.30087 1.48069C0.292522 1.10347 0.689048 0.853279 1.02593 1.02321L23.8373 12.5298C24.1843 12.7048 24.2076 13.1916 23.8789 13.399L1.63277 27.4354C1.30402 27.6428 0.874685 27.4122 0.866086 27.0236L0.30087 1.48069Z",
                          fill: "white"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _vm._m(3)
            ]),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "preview",
                staticClass: "card-body p-0 position-relative"
              },
              [
                _c("previewComponent", {
                  attrs: {
                    height: _vm.height,
                    width: _vm.width,
                    showShadow: _vm.showShadow,
                    showSkeleton: _vm.showSkeleton,
                    selectedAnimation: _vm.selectedAnimation,
                    selectedFbxModel: _vm.selectedFbxModel
                  }
                })
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn" }, [
      _c("i", { staticClass: "fas fa-backward fa-xl" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn" }, [
      _c("i", { staticClass: "fas fa-step-backward fa-xl" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn" }, [
      _c("i", { staticClass: "fas fa-step-forward fa-xl" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn" }, [
      _c("i", { staticClass: "fas fa-forward fa-xl" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("span", [
            _c("i", { staticClass: "fas fa-video" }),
            _vm._v("\n                  Preview")
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e899fbe", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e899fbe","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/simulation.vue
// module id = null
// module chunks = 